import React from 'react';
import {
  Divider,
  IconButton,
  List,
  Menu,
  Text,
} from 'react-native-paper';
import {FolderType, Media} from '../../../types';
import {
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';
import {ProjectsStackedParams} from '../../../types/nav';
import {ImageBackground, View} from 'react-native';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  setFolderMenuItemId,
  setToastText,
} from '../../../store/slices/ui';
import {recursiveShare} from '../../../api';
import {TouchableOpacity} from 'react-native-gesture-handler';
import {MediaItemStyles} from './mediaitem';
function ProjectItem({
  item,
  folderType,
  onRemoveFolder,
  width,
  onDragEnd,
  onDragStart,
  showMenu,
  hideMenu,
}: {
  item: Media;
  folderType: FolderType;
  onRemoveFolder: (item: {id: string}) => void;
  width: number;
  onDragEnd?: () => void;
  onDragStart?: () => void;
  showMenu?: () => void;
  hideMenu?: () => void;
}) {
  const navigation =
    useNavigation<NavigationProp<ProjectsStackedParams>>();
  const projectType =
    folderType === FolderType.encoder
      ? 'EncoderProject'
      : 'EditorProject';
  const projectIcon =
    folderType === FolderType.editor ? 'film' : 'matrix';
  const dispatch = useAppDispatch();
  const shareAllMedia = () => {
    dispatch(setFolderMenuItemId({itemId: undefined}));
    recursiveShare(item);
    dispatch(setToastText('All project files have been shared'));
  };
  const height = 100;
  const isMenuOpen =
    useAppSelector(state => state.ui.folderItemMenuOpen) === item.id;
  const rightItem = (props: any) => (
    <View style={{flexDirection: 'row', flexWrap: 'wrap'}}>
      <>
        <TouchableOpacity
          onPressIn={onDragStart}
          onPressOut={onDragEnd}
          style={{pointerEvents: 'auto'}}>
          <IconButton icon={'dots-grid'} />
        </TouchableOpacity>
        <Menu
          anchor={
            <IconButton icon={'dots-vertical'} onPress={showMenu} />
          }
          style={{marginTop: 50}}
          visible={isMenuOpen}
          onDismiss={hideMenu}>
          <>
            <Menu.Item
              leadingIcon={'heart'}
              title={'Share All Media'}
              onPress={() => shareAllMedia()}
            />
            <Divider />
          </>
          {/* <>
            <Menu.Item
              leadingIcon={'share'}
              title={'Share Project'}
              onPress={() => () => {}}
            />
            <Divider />
          </> */}
          {/* <>
              <Menu.Item
                leadingIcon={folderAccesory}
                title={'Edit Folder'}
                onPress={edit}
              />
              <Divider />
            </> */}
          <>
            <Menu.Item
              leadingIcon={'delete'}
              title={'Delete Project'}
              onPress={() => onRemoveFolder(item)}
            />
          </>
        </Menu>
      </>
    </View>
  );
  return (
    <View style={{width, height}}>
      <Divider />
      <List.Item
        style={{padding: 19, width, height, zIndex: 2}}
        titleMaxFontSizeMultiplier={0.5}
        titleNumberOfLines={2}
        descriptionNumberOfLines={2}
        title={item.title}
        onPress={() => {
          navigation.navigate({
            name: projectType,
            params: {
              projectId: item.id,
              mnemonic: item.mnemonic,
              parentFolderId: item.folderId,
            },
          });
        }}
        left={() => <List.Icon icon={projectIcon} />}
        right={rightItem}
      />

      {item.thumbnail || item.image ? (
        <ImageBackground
          source={{
            uri: item.thumbnail || item.image,
            cache: 'force-cache',
          }}
          resizeMethod="resize"
          resizeMode="cover"
          style={{
            ...MediaItemStyles.image,
            height,
            width,
          }}
          imageStyle={{...MediaItemStyles.image, height, width}}
        />
      ) : null}
    </View>
  );
}

export default ProjectItem;
